import Swiper from 'swiper/bundle';

export default function blockImageSlider() {
  document.querySelectorAll('.block-slider-text-image:not(.block-slider-text-image--disabled)').forEach(function (slider) {
    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: true,
      grabCursor: true,
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: false,
          translate: ["-120%", 0, -1000],
          scale: 0.3,
          opacity: 0,
        },
        next: {
          shadow: false,
          translate: ["120%", 0, -1000],
          scale: 0.3,
          opacity: 0,
        },
      },
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
}